import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2605/logo.png';
import Title from '../img/event/2605/title.png';
import Text from '../img/event/2605/text.png';
import GiftBox from '../img/event/2605/gift-box.png';
import SpecialGift from '../img/event/2605/special-gift.png';
import JcUnivCoupon from '../img/event/2605/jc-univ-coupon.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';

const HomeschoolEvent202604 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#4BCAFA]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="flex flex-col gap-10 pt-8 sm:gap-20 sm:pt-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 젭스 영어교실 로고 */}
            <div className="mx-auto flex max-w-[100px] pb-4 sm:max-w-[150px] md:max-w-[180px]">
              <img src={Logo} alt="젭스 영어교실 로고" />
            </div>

            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex flex-col">
                <img
                  src={Title}
                  alt="5월! 하면 어린이날이지! 어린이날 선물이 고민된다면? 오월에 선물해오 금방 질리는 장난감보다 평생 남는 말씀으로!"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FF8FCD]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-8 px-5 py-6 sm:gap-10 sm:py-20">
          {/* 말풍선 섹션 */}
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 타이틀 문구 */}
            <div className="pb-2 pt-2 text-center text-xl font-bold text-black sm:text-2xl">
              이번 어린이날,
              <br />
              진짜 선물을 주세요!
            </div>

            {/* 말풍선 1 */}
            <div className="flex w-full -translate-x-6 justify-center gap-6 rounded-full bg-[#FFFFFF]/60 px-10 py-3 drop-shadow-sm sm:rounded-full">
              <p className="text-center text-sm font-medium text-black sm:text-lg">
                <span className="font-semibold">
                  금세 관심이 사라지는 장난감
                </span>
              </p>
            </div>
            {/* 말풍선 2 */}
            <div className="flex w-full translate-x-6 justify-center gap-6 rounded-full bg-[#FFFFFF]/40 px-10 py-3 drop-shadow-sm sm:rounded-full">
              <p className="text-center text-sm font-medium text-black sm:text-lg">
                <span className="font-semibold">멈추기 쉽지 않은 게임기</span>
              </p>
            </div>
            {/* 동그라미 */}
            <div className="flex h-3 w-3 items-center justify-center rounded-full bg-[#FFBCE1]" />
            <div className="flex h-3 w-3 items-center justify-center rounded-full bg-[#FFA5D7]" />
          </section>

          <div className="mx-auto flex max-w-[250px] pb-4 sm:max-w-[330px] md:max-w-[400px]">
            <img
              src={Text}
              alt="하나님 말씀으로 배우는 영어는 아이의 평생 자산!"
            />
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FFEE8D]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-10 px-5 py-10 sm:gap-20 sm:py-20">
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 문구 */}
            <div className="text-center text-sm text-black sm:text-2xl">
              여기서 잠깐!
              <br />
              나한테도 선물이 있을까...?🫢
            </div>

            {/* 이미지 */}
            <div className="mx-auto flex max-w-[150px] pb-4 sm:max-w-[150px] md:max-w-[150px]">
              <img src={GiftBox} alt="선물 상자" />
            </div>

            {/* 문구 */}
            <div className="pb-6 text-center text-lg font-extrabold text-black sm:text-2xl">
              아이가 공부할 때! 나도 공부하자!
              <br />
              정철대학 오픈 기념 특별 혜택!
            </div>

            {/* 이미지 */}
            <div className="mx-auto flex max-w-[150px] pb-2 sm:max-w-[150px] md:max-w-[150px]">
              <img src={SpecialGift} alt="특별 사은품" />
            </div>

            {/* 문구 */}
            <div className="pb-2 text-center text-lg font-bold text-[#7A2223] sm:text-2xl">
              구독 한 번으로 정철선생님의 인기 강의를
              <br />
              무제한으로 들을 수 있는
            </div>

            {/* 이미지 */}
            <div className="mx-auto flex max-w-[230px] sm:max-w-[250px] md:max-w-[250px]">
              <img src={JcUnivCoupon} alt="정철대학 1개월 수강권" />
            </div>
          </section>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 섹션 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 서브타이틀 텍스트 */}
              <div className="text-base font-semibold text-black sm:text-2xl">
                말씀으로 영어까지 정복하는!
              </div>
              {/* 타이틀 텍스트 */}
              <div className="text-xl font-extrabold text-black sm:text-3xl">
                5월 온라인 설명회
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex items-center justify-center bg-[#48C3EB]">
        <div className="m-auto flex w-full max-w-[720px] flex-col px-5 py-10 sm:px-10 sm:py-16">
          {/* 타이틀 */}
          <p className="text-center text-xl font-extrabold leading-relaxed text-[#303048] sm:text-4xl">
            우리 아이가 진짜 좋아할 선물,
            <br />
            젭스영어교실!
          </p>

          {/* 흰색 카드 */}
          <section className="mt-8 rounded-xl bg-white px-5 py-6 sm:mt-12 sm:px-10 sm:py-10">
            <div className="flex flex-col gap-7 sm:gap-10">
              <div className="flex flex-col items-center gap-3 text-center">
                <div className="rounded-full border border-[#EB5D1A] px-6 py-2 text-base font-extrabold text-[#EB5D1A] sm:text-2xl">
                  아이가 좋아할 수밖에 없어요
                </div>
                <p className="text-sm font-bold leading-relaxed text-black sm:text-xl">
                  억지로 시키는 공부가 아니라,
                  <br />
                  성경 이야기로 놀듯이 배우니까요
                </p>
              </div>

              <div className="flex flex-col items-center gap-3 text-center">
                <div className="rounded-full border border-[#EB5D1A] px-6 py-2 text-base font-extrabold text-[#EB5D1A] sm:text-2xl">
                  영어를 잘 할 수밖에 없어요
                </div>
                <p className="text-sm font-bold leading-relaxed text-black sm:text-xl">
                  삽화기억술로 외우고, 바이블 스토리로 말하고,
                  <br />
                  암송이 회화가 되는 순간이 오거든요
                </p>
              </div>

              <div className="flex flex-col items-center gap-3 text-center">
                <div className="rounded-full border border-[#EB5D1A] px-6 py-2 text-base font-extrabold text-[#EB5D1A] sm:text-2xl">
                  아이와 더 많은 시간을 보내요
                </div>
                <p className="text-sm font-bold leading-relaxed text-black sm:text-xl">
                  엄마와 함께하는 시간이
                  <br />
                  그대로 영어 수업이 됩니다
                </p>
              </div>
            </div>
          </section>

          {/* 타이틀 */}
          <div className="mt-10 flex flex-col items-center text-center sm:mt-16">
            <p className="mb-2 inline-block bg-[#FFEE8D] px-2 text-sm font-bold text-black sm:text-xl">
              말씀 안에서
            </p>
            <p className="inline-block bg-[#FFEE8D] px-2 text-sm font-bold text-black sm:text-xl">
              하나님의 지혜로 깨달아가는 영어
            </p>

            <p className="mt-4 text-2xl font-extrabold text-white sm:text-5xl">
              '젭스'
            </p>

            <p className="mt-6 text-center text-sm font-bold leading-relaxed text-black sm:text-xl">
              어떤 선물보다 오래, 깊이 아이 곁에 남습니다
            </p>

            <p className="mt-4 text-center text-sm font-bold leading-relaxed text-white sm:text-xl">
              5월에 가장 귀한 가치를
              <br />
              우리 아이에게 선물해 보여 어떨까요? 🎁
            </p>
          </div>

          {/* 버튼 */}
          <div className="mt-9 sm:mt-14">
            <DoubleLineWithCursorButton
              onClick={() => {
                window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
              }}
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="px-5 py-3 text-base font-bold sm:px-8 sm:py-5 sm:text-2xl md:text-4xl">
                5월 젭스영어교실&nbsp;
                <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
              </div>
            </DoubleLineWithCursorButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202604;
